import React, { useEffect, useState } from "react";
import axios from "../../api/axiosInstance";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import GlobalLoader from "./GlobalLoader";

const ProfileViewsListPage = () => {
  const [viewedByMeProfiles, setViewedByMeProfiles] = useState([]);
  const [viewedMyProfileProfiles, setViewedMyProfileProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("viewed_by_me");

  const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");

  const fetchProfileViews = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/api/profile-views/", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      setViewedByMeProfiles(res.data.viewed_by_me);
      setViewedMyProfileProfiles(res.data.viewed_my_profile);
      setLoading(false);
    } catch (error) {
      console.error(error.response?.data || error.message);
      toast.error("Failed to fetch profile views.");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfileViews();
  }, []);

  if (loading) {
    return <GlobalLoader />;
  }

  const displayedProfiles =
    activeTab === "viewed_by_me" ? viewedByMeProfiles : viewedMyProfileProfiles;

  return (
    <div className="p-4 w-full max-w-4xl mx-auto">
      <div className="flex justify-center gap-2 md:gap-4 mb-6">
        <button
          onClick={() => setActiveTab("viewed_by_me")}
          className={`px-3 md:px-4 py-2 rounded text-sm md:text-base ${
            activeTab === "viewed_by_me"
              ? "bg-pink-600 text-white"
              : "bg-gray-200"
          }`}
        >
          <span className="md:hidden">
            Viewed By You ({viewedByMeProfiles.length})
          </span>
          <span className="hidden md:inline">
            Profiles Viewed By You ({viewedByMeProfiles.length})
          </span>
        </button>

        <button
          onClick={() => setActiveTab("viewed_my_profile")}
          className={`px-3 md:px-4 py-2 rounded text-sm md:text-base ${
            activeTab === "viewed_my_profile"
              ? "bg-pink-600 text-white"
              : "bg-gray-200"
          }`}
        >
          <span className="md:hidden">
            Viewed You ({viewedMyProfileProfiles.length})
          </span>
          <span className="hidden md:inline">
            Profiles Who Viewed You ({viewedMyProfileProfiles.length})
          </span>
        </button>
      </div>

      {displayedProfiles.length === 0 ? (
        <p className="text-center text-gray-500 mt-10">
          No profiles to display.
        </p>
      ) : (
        <div className="flex flex-col gap-4">
          {displayedProfiles.map((match) => (
            <div
              key={match.id}
              className="bg-white rounded shadow p-4 flex flex-col sm:flex-row items-center sm:items-start gap-4"
            >
              <Link to={`/profile/${match.user.id}`}>
                <img
                  src={
                    match.photo || require("../../assets/default_image.webp")
                  }
                  alt={match.user.first_name}
                  className="w-32 h-32 object-cover rounded"
                />
              </Link>
              <div className="flex-1">
                <Link
                  to={`/profile/${match.user.id}`}
                  className="flex-shrink-0 text-decoration-none"
                >
                  <p className="font-semibold text-lg">
                    {match.user.first_name} {match.user.last_name}
                  </p>
                  <p className="text-sm text-gray-600 mb-2">
                    {calculateAge(match.dob)} yrs • {match.height_feet}'
                    {match.height_inches}" • {match.religion} •{" "}
                    {match.marital_status} • {match.highest_education} •{" "}
                    {match.employed_in} • {match.city}
                  </p>
                </Link>
                {activeTab === "viewed_by_me" && (
                  <p className="text-xs text-gray-500 mt-2">
                    You viewed this profile recently.
                  </p>
                )}
                {activeTab === "viewed_my_profile" && (
                  <p className="text-xs text-gray-500 mt-2">
                    Viewed your profile recently.
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProfileViewsListPage;
